var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-hint mt-12",class:[
        _vm.status && ("text-color-" + _vm.status)
    ]},[_vm._v(_vm._s(_vm.hint))])}
var staticRenderFns = []

export { render, staticRenderFns }